import { FiscalCorrectionListResponse, FiscalSaleCheckResponse, FiscalTaxProfileListResponse, FiscalTaxProfileResponse, FiscalCodeListResponse, FiscalDocumentListResponse, FiscalDocumentResponse, FiscalServiceItemListResponse, FiscalServiceItemResponse, FiscalSettingsResponse, } from '@aeris/contracts';
import { request } from "./client.js";
/** `/api/v1/fiscal` — a nota fiscal (F371, ADR-0051). */
export const fetchFiscalSettings = async (signal) => FiscalSettingsResponse.parse(await request('/api/v1/fiscal/settings', { signal }));
export const saveFiscalSettings = async (input) => FiscalSettingsResponse.parse(await request('/api/v1/fiscal/settings', { method: 'PUT', body: input }));
export const uploadFiscalCertificate = async (input) => FiscalSettingsResponse.parse(await request('/api/v1/fiscal/certificate', { method: 'PUT', body: input }));
export const removeFiscalCertificate = async () => FiscalSettingsResponse.parse(await request('/api/v1/fiscal/certificate', { method: 'DELETE' }));
export const saveFiscalRegime = async (input) => FiscalSettingsResponse.parse(await request('/api/v1/fiscal/regime', { method: 'PUT', body: input }));
// ---------------------------------------------------------------------------
// A nota de serviço (F372)
// ---------------------------------------------------------------------------
export const fetchFiscalCodes = async (table, term, signal) => FiscalCodeListResponse.parse(await request(`/api/v1/fiscal/${table}?q=${encodeURIComponent(term)}`, {
    signal,
}));
export const fetchFiscalServiceItems = async (signal) => FiscalServiceItemListResponse.parse(await request('/api/v1/fiscal/service-items', { signal }));
export const createFiscalServiceItem = async (input) => FiscalServiceItemResponse.parse(await request('/api/v1/fiscal/service-items', {
    method: 'POST',
    body: input,
}));
export const updateFiscalServiceItem = async (id, input) => FiscalServiceItemResponse.parse(await request(`/api/v1/fiscal/service-items/${id}`, {
    method: 'PUT',
    body: input,
}));
export const fetchFiscalDocuments = async (query, signal) => {
    const params = new URLSearchParams({
        page: String(query.page),
        pageSize: String(query.pageSize),
    });
    if (query.status !== undefined)
        params.set('status', query.status);
    if (query.q !== undefined && query.q !== '')
        params.set('q', query.q);
    return FiscalDocumentListResponse.parse(await request(`/api/v1/fiscal/documents?${params.toString()}`, { signal }));
};
export const createNfse = async (input) => FiscalDocumentResponse.parse(await request('/api/v1/fiscal/documents/nfse', {
    method: 'POST',
    body: input,
}));
export const retryFiscalDocument = async (id) => FiscalDocumentResponse.parse(await request(`/api/v1/fiscal/documents/${id}/retry`, { method: 'POST' }));
export const cancelFiscalDocument = async (id, input) => FiscalDocumentResponse.parse(await request(`/api/v1/fiscal/documents/${id}/cancel`, {
    method: 'POST',
    body: input,
}));
/** O endereço do arquivo: o navegador abre com a sessão de quem está logado. */
export const fiscalDocumentFileUrl = (id, file) => `/api/v1/fiscal/documents/${id}/${file}`;
// ---------------------------------------------------------------------------
// A nota de produto (F373)
// ---------------------------------------------------------------------------
export const fetchFiscalTaxProfiles = async (signal) => FiscalTaxProfileListResponse.parse(await request('/api/v1/fiscal/tax-profiles', { signal }));
export const createFiscalTaxProfile = async (input) => FiscalTaxProfileResponse.parse(await request('/api/v1/fiscal/tax-profiles', {
    method: 'POST',
    body: input,
}));
export const updateFiscalTaxProfile = async (id, input) => FiscalTaxProfileResponse.parse(await request(`/api/v1/fiscal/tax-profiles/${id}`, {
    method: 'PUT',
    body: input,
}));
export const assignFiscalTaxProfile = async (variantId, input) => {
    await request(`/api/v1/fiscal/variants/${variantId}/tax-profile`, {
        method: 'PUT',
        body: input,
    });
};
export const fetchFiscalSaleCheck = async (saleId, signal) => FiscalSaleCheckResponse.parse(await request(`/api/v1/fiscal/sales/${saleId}/check`, { signal }));
export const createNfe = async (input) => FiscalDocumentResponse.parse(await request('/api/v1/fiscal/documents/nfe', {
    method: 'POST',
    body: input,
}));
export const fetchFiscalCorrections = async (id, signal) => FiscalCorrectionListResponse.parse(await request(`/api/v1/fiscal/documents/${id}/corrections`, { signal }));
export const createFiscalCorrection = async (id, input) => FiscalCorrectionListResponse.parse(await request(`/api/v1/fiscal/documents/${id}/corrections`, {
    method: 'POST',
    body: input,
}));
//# sourceMappingURL=fiscal.js.map